import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export enum GetUserListSubtype {
  LoadNextPage = "LOAD_NEXT_PAGE",
  LoadFirstPage = "LOAD_FIRST_PAGE",
}

export const GET_USER_LIST = "GET_USER_LIST";

export interface GetUserListAction extends Action {
  type: typeof GET_USER_LIST;
  organization: OrganizationKeyName;
  subtype: GetUserListSubtype;
}

export const getUserListAction = (
  subtype: GetUserListSubtype,
  organization: OrganizationKeyName
): GetUserListAction => ({
  type: GET_USER_LIST,
  subtype,
  organization,
});
